import { render, staticRenderFns } from "./PacOptionalTable.vue?vue&type=template&id=bca34626&scoped=true"
import script from "./PacOptionalTable.vue?vue&type=script&lang=ts"
export * from "./PacOptionalTable.vue?vue&type=script&lang=ts"
import style0 from "./PacOptionalTable.vue?vue&type=style&index=0&id=bca34626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca34626",
  null
  
)

export default component.exports